import React, { memo, useEffect } from 'react';
import { WorkspacesState } from 'common/store/workspaces/reducer';
import { useDispatch } from 'react-redux';
import CommonSidebar from 'common/components/sidebar/CommonSideBar';
import { toggleSideBar } from 'common/store/workspaces/actions';
import { CommonContextState } from 'common/store/context/types';
import {
    filterAvailableGroupsForUserInCommittee,
    getNumberOfVisibleWorkspaces, getVisibleWorkspaces,
} from '../../services/workspaceSchemeService';
import { Committee } from '../../services/committeeService';
import { getPartyCommitteeIdForContext } from '../../services/gradingPartyService';
import navigationListService from '../../services/navigationListService';

interface SidebarProps {
    context: CommonContextState;
    mode: string;
    workspaces: WorkspacesState;
    committees?: Committee[];
}

const Sidebar = memo((props: SidebarProps) => {
    const dispatch = useDispatch();
    const {
        mode, workspaces, context, committees,
    } = props;
    const { partyState: { gradingPartyDocument } } = context;
    const selectedCommitteeId = getPartyCommitteeIdForContext(gradingPartyDocument);
    let availableWorkspaceGroups = getVisibleWorkspaces(workspaces);
    if (committees) {
        availableWorkspaceGroups = filterAvailableGroupsForUserInCommittee(availableWorkspaceGroups, selectedCommitteeId);
    }
    if (availableWorkspaceGroups.length === 0) {
        return null;
    }

    useEffect(() => {
        const visibleWorkspacesCount = getNumberOfVisibleWorkspaces(workspaces, selectedCommitteeId);

        if (visibleWorkspacesCount > 1) {
            if (!workspaces.sideBarExpanded) {
                dispatch(toggleSideBar(true));
            }
        } else if (workspaces.sideBarExpanded) {
            dispatch(toggleSideBar(false));
        }
    }, [selectedCommitteeId]);


    return (
        <CommonSidebar
            mode={mode}
            workspaces={workspaces}
            availableWorkspaceGroups={availableWorkspaceGroups}
            context={context}
            navigationCallback={navigationListService.navigateToWorkspace}
        />
    );
});

export default Sidebar;
